import { SingleTenantStatsComponent } from "./components/single-tenant-stats/single-tenant-stats.component";

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SingleTenantOverviewComponent } from "./components/single-tenant-overview/single-tenant-overview.component";
import { SharedModule } from "../shared/shared.module";
import { MatCardModule } from "@angular/material/card";
import { UserDashboardComponent } from "./components/user-dashboard/user-dashboard.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { RouterModule } from '@angular/router';

@NgModule({
    exports: [SingleTenantStatsComponent, UserDashboardComponent],
    imports: [
        CommonModule,
        SharedModule,
        MatCardModule,
        SharedModule,
        MatProgressBarModule,
        MatDividerModule,
        MatFormFieldModule,
        MatSelectModule,
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        RouterModule,
        SingleTenantOverviewComponent,
        SingleTenantStatsComponent,
        UserDashboardComponent
    ],
})
export class DashboardModule {}
